module.exports = __webpack_public_path__ + "img/cadiz_hero_card.dfe119aa.png";